import { POST_LOADER_DELAY } from '@/constants';
import { IProduct } from '@/services/product';
import messages from '../messages';

export default function(context: any) {
  context.$store.commit('loader/ADD', {
    title: 'Creating product',
    promise: context.create().then(
      (product: IProduct) => {
        context.$router.replace({
          name: 'product',
          params: {
            productId: product.id,
          },
        });
      })
      .catch((error: any) => {
        console.error(error);

        context.$store.commit('dialog/CREATE', {
          title: 'Error :(',
          content: messages.ERROR_PRODUCT_CREATE,
          compact: true,
          delay: POST_LOADER_DELAY,
          buttons: [
            {
              text: 'Close',
              click: (dialog: any) => dialog.close(),
            },
          ],
        });
      }),
    });
}
